import { Container } from '@mui/material'

import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import { useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneServices } from '@features/hooks/LandingZones/services'

import CollapsibleTable from '@components/CollapsibleTable'

import Nodata from '@views/Components/Nodata'
import Membership from '@views/Landingzones/Detail/Components/Membership'

export const Services = (props) => {
    const lzDataStore = useSelector(state => state.landingZones)
    const dataStore = useSelector(state => state.landingZoneServices)

    const { load: loadLz, getProvider } = useLandingZones()
    const { load: loadServices } = useLandingZoneServices()

    const [data, setData] = useState([])
    const [provider, setProvider] = useState(null)

    useEffect(() => {
        if (!(lzDataStore.formated.mode > -1))
            loadLz(() => { loadServices(props.id) })
        else loadServices(props.id)
    }, [])

    useEffect(() => {
        setData(dataStore.formated)
        if (dataStore?.loaded) setProvider(getProvider(dataStore?.loaded))
    }, [dataStore.formated])

    const headers = useRef([
        {field: 'name', headerName: 'Name', isFirst: true},
        {field: 'objectId', headerName: 'Object ID'},
        {field: 'appId', headerName: 'App ID'}
    ])

    return (
        <Container maxWidth={'xl'} sx={{mt: 2}}>
            {(data && data.length > 0) && (
                <CollapsibleTable
                    headers={headers.current}
                    rows={data}
                    stickyHeader
                    sxGrid={{height: `calc(100vh - (64px + 193px))`}}
                >
                    <Membership provider={provider} info={'In addition to users with permission to manage any applications, the users listed here can view and edit this application registration. If the user setting “Restrict access to Azure AD administration portal” is set to Yes, non-admin users will not be able to use the Azure portal to manage the applications they own.'}/>
                </CollapsibleTable>
            )}

            {(data && data.length < 1) && (<Nodata label={'No data to display'} icon={'search_off'} noIcon img />)}
        </Container>
    )
}

export default Services